import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Crown, Gift, Star, Sparkles } from 'lucide-react';

interface WelcomeModalProps {
  open: boolean;
  onClose: () => void;
  firstName: string;
  points: number;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ 
  open, 
  onClose, 
  firstName, 
  points 
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md text-center">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="relative">
              <div className="p-4 bg-gradient-to-br from-secondary to-secondary/80 rounded-full">
                <Crown className="h-12 w-12 text-secondary-foreground" />
              </div>
              <div className="absolute -top-1 -right-1">
                <Sparkles className="h-6 w-6 text-secondary animate-pulse" />
              </div>
            </div>
          </div>
          <DialogTitle className="text-2xl font-serif">
            ¡Bienvenido al Club Reyes, {firstName}!
          </DialogTitle>
          <DialogDescription className="text-base mt-2">
            Ya eres parte de nuestra familia. Disfruta de tus primeros puntos de regalo.
          </DialogDescription>
        </DialogHeader>
        
        <div className="my-6">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-secondary/20 to-primary/10 px-6 py-4 rounded-xl border border-secondary/30">
            <Gift className="h-8 w-8 text-secondary" />
            <div className="text-left">
              <p className="text-sm text-muted-foreground">Tu regalo de bienvenida</p>
              <p className="text-3xl font-bold text-foreground">
                +{points} <span className="text-lg font-normal">puntos</span>
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3 text-left bg-muted/30 p-4 rounded-lg">
          <h4 className="font-semibold text-foreground flex items-center gap-2">
            <Star className="h-4 w-4 text-secondary" />
            ¿Cómo funciona?
          </h4>
          <ul className="text-sm text-muted-foreground space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-secondary font-bold">1€</span>
              <span>= 1 punto en cada compra</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-secondary font-bold">QR</span>
              <span>Muestra tu código en caja para acumular</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-secondary font-bold">🎁</span>
              <span>Canjea tus puntos por cafés, dulces y más</span>
            </li>
          </ul>
        </div>

        <Button onClick={onClose} className="w-full mt-4" size="lg">
          ¡Empezar a acumular!
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
